var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.requiredResourcesAreReady || _vm.redirectInPending)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"db-spinner"})]):_vm._e(),(_vm.requiredResourcesAreReady)?_c('FunnelContainer',[_c('ThemeProvider',[_c('router-view')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }